export const typeOfActivity = [
    {value: 'construction' , label: 'Строительство' },
];